<template>
  <div class="tableballbox">
    <template v-if="datasType === 'balls'">
      <template v-if="lotteryType === 'xy28'">
        <div
          v-for="(ball, ballIndex) in datas"
          :key="`balls-${ballIndex}-${ball.val}`"
          class="tableballbox__item"
          :class="{'addplus': ballIndex !== datas.length - 1,
                   'addequal': ballIndex === datas.length - 1}"
        >
          <div class="ball size-middle color--blue circle">
            <span class="ball__number">{{ ball.val }}</span>
          </div>
        </div>
        <div class="tableballbox__item">
          <div class="ball size-middle color--red circle">
            <span class="ball__number">{{ getZongHe(datas) }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-for="(ball, ballIndex) in datas"
          :key="`balls-${ballIndex}-${ball.val}`"
          class="tableballbox__item"
        >
          <div class="ball size-middle" :class="[setBallClass(ball.val), setBallAward(ball.isCorrect)]">
            <span v-if="!isK3 && !isCqssc" class="ball__number">{{ ball.val }}</span>
            <div v-if="ball.isCorrect" class="ball__subnumber">
              <span class="ball__subnumber__text">中</span>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div
        v-for="(pred, predIndex) in datas"
        :key="`balls-${predIndex}-${pred.val}`"
        class="tableballbox__item"
      >
        <div class="ball size-middle" :class="[setPredClass(pred.val), setPredAward(pred.isCorrect)]">
          <span v-if="!isCqssc" class="ball__number">{{ pred.val }}</span>
          <div v-if="pred.isCorrect" class="ball__subnumber">
            <span class="ball__subnumber__text">中</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'WebLotteryBalls',
  props: {
    lotteryCode: {
      type: String,
      default: undefined
    },
    lotteryType: {
      type: String,
      default: ''
    },
    datasType: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isCqssc() {
      return this.lotteryCode === 'cqssc'
    },
    isK3() {
      return this.lotteryType === 'k3'
    }
  },
  methods: {
    setBallClass(ballNum) {
      if (this.lotteryCode === 'cqssc') return `zodiac-${ballNum}`
      switch (this.lotteryType) {
        case 'pk10':
          return parseInt(ballNum, 10) === 10 ? `ball-${ballNum}` : `ball-0${ballNum}`
        case 'k3':
          return `dice-${ballNum}`
        case 'ssc':
        case '11x5':
          return 'color--blue circle'
      }
    },
    setBallAward(isCorrect) {
      const isHmTypeBall = this.lotteryType === 'pk10' || this.lotteryType === 'ssc' || this.lotteryType === '11x5'
      if (isHmTypeBall) return isCorrect ? 'hightlight' : 'color-disable'
    },
    setPredClass(ballNum) {
      if (this.lotteryCode === 'cqssc') return `zodiac-${ballNum}`
      switch (this.lotteryType) {
        case 'pk10':
          return parseInt(ballNum, 10) === 10 ? `ball-${ballNum}` : `ball-0${ballNum}`
        case 'k3':
        case 'xy28':
          return 'color--outline circle'
        case 'ssc':
        case '11x5':
          return 'color--blue circle'
      }
    },
    setPredAward(isCorrect) {
      return isCorrect ? 'hightlight' : ''
    },
    getZongHe(balls) {
      return balls.reduce((acc, ball, idx) => {
        acc += ball.val
        return acc
      }, 0)
    }
  }
}
</script>
